import { z } from 'zod';

interface BuildOrderConditionDefinitionsSchemaParams {
  requiredMessage: string;
}

export const buildOrderConditionDefinitionsSchema = ({
  requiredMessage,
}: BuildOrderConditionDefinitionsSchemaParams) =>
  z
    .object({
      orderCollectionId: z.string().nullable(),
      saleTypeId: z.string().nullable(),
      branchId: z.string().nullable(),
      shippingCompanyId: z.string().nullable(),
      brandFreightTypeId: z.string().nullable(),
      orderOperationCode: z.string().nullable(),
      orderChargeTypeCode: z.string().nullable(),
      orderBatchItemCode: z.string().nullable(),
      orderClassificationTypeCode: z.string().nullable(),
      orderClassificationCode: z.string().nullable(),
      emitInvoice: z.boolean(),
    })
    .superRefine((values, ctx) => {
      if (!values.orderClassificationTypeCode || values.orderClassificationCode) {
        return;
      }

      ctx.addIssue({
        code: 'custom',
        path: ['orderClassificationCode'],
        message: requiredMessage,
      });
    });

export type OrderConditionDefinitionsFormValues = z.infer<
  ReturnType<typeof buildOrderConditionDefinitionsSchema>
>;
